import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.8416 13.825L9.02496 10L12.8416 6.175L11.6666 5L6.66663 10L11.6666 15L12.8416 13.825Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgKeyboardArrowLeft);
export default ForwardRef;
